import { sortedPostsPerTag, sortPosts } from "./SortedPostPerTagRepo";

export default async function getByQuery(postRepository, queryConditions, tag) {
    const [postsPerTag, postsSnapshot] = await Promise.all([sortedPostsPerTag(tag), postRepository(queryConditions).get()])
    const post_ids = postsPerTag.exists ? postsPerTag.data().post_ids : []
    const posts = postsSnapshot.docs.map((doc) => ({ key: doc.id, ...doc.data() }))
    const result = sortPosts(post_ids, posts)
    return result
}